(() => {
  const menuButton = document.querySelector('[data-inner-menu-toggle]');
  const menu = document.querySelector('[data-inner-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.body.classList.toggle('inner-menu-open', open);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!main) return;
        main.src = button.dataset.image;
        main.srcset = button.dataset.srcset || '';
        main.alt = button.dataset.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-current-price]');
    const compare = section.querySelector('[data-compare-price]');
    const button = section.querySelector('[data-product-submit]');
    if (!select) return;
    const update = () => {
      const option = select.options[select.selectedIndex];
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.querySelector('span').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };
    select.addEventListener('change', update);
    update();
  });

  document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || form.dataset.redirect === 'true') return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const original = button?.textContent;
      if (button) { button.disabled = true; button.textContent = button.dataset.loading || 'Adding…'; }
      try {
        const response = await fetch(`${window.NARTISTIC_ROUTES?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) throw new Error('add failed');
        if (button) button.textContent = button.dataset.added || 'Added';
        window.setTimeout(() => { if (button) { button.disabled = false; button.textContent = original; } }, 1200);
      } catch (error) {
        form.submit();
      }
    });
  });
})();
